import { mobileLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  z-index: 5;
  width: 100%;
  margin: 20px 0 30px 0;
`;

export const Icon = styled.button`
  & svg {
    font-size: 22px;
  }
`;

export const Input = styled.input`
  display: flex;
  flex: 1;
  background: transparent;
  border: none;
  font-size: 16px;
  overflow: hidden;
  color: ${(props) => props.theme.textDark};
  height: 100%;
  line-height: 22px;

  &::placeholder {
    color: ${(props) => props.theme.backgroundMid};
    font-size: 20px;
  }

  &::-webkit-search-decoration,
  ::-webkit-search-cancel-button,
  ::-webkit-search-results-button,
  ::-webkit-search-results-decoration {
    display: none;
  }

  &::selection {
    color: ${(props) => props.theme.white};
    background: ${(props) => props.theme.primary};
  }
`;

export const SearchInputContainer = styled.div`
  flex: 1;
`;

export const LoadingBox = styled.div`
  margin: 5px 10px 0 0;
`;

export const SearchInput = styled.div`
  background-color: ${(props) => props.theme.background};
  height: 70px;
  display: flex;
  flex: 1;
  border-radius: 35px;
  min-width: 0;
  align-items: center;
  padding: 0 30px;
  gap: 15px;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.1);

  @media (${mobileLargeMax}) {
    padding: 0 15px;
    gap: 10px;

    ${Input}::placeholder {
      font-size: 16px;
    }

    ${Icon} svg {
      font-size: 18px;
    }
  }
`;
